import React from "react";
import { useNavigate } from "react-router-dom";
import CustomViewButton from "../../../CustomComponent/custom_view_button";

const tableHead = [
  "Sr.",
  "PO Number",
  "GRN Number",
  "Vendor Details",
  "Po Final Amount",
  "Grn Final Amount",
  "Extra Payment Amount",
  "Used Payment Amount",
  "Pending Payment Amount",
  "Status",
  "Actions",
];
const POGrnTable = ({ PoGrn = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/Po-Grn-Vendor-Payment/View/${id}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {PoGrn?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>
                  <a
                    href={`/purchase-order/view/${parseInt(
                      item?.poNumber?.split("/").at(-1),
                      10
                    )}`}
                  >
                    {item?.poNumber || "N/A"}
                  </a>
                </td>
                <td>
                  <a
                    href={`/view-grn-items/${parseInt(
                      item?.grnNumber?.split("/").at(-1),
                      10
                    )}`}
                  >
                    {" "}
                    {item?.grnNumber || "N/A"}
                  </a>
                </td>
                <td>
                  <a
                    href={`/purchase-vendor-management/view-vendor/${item?.vendor?.id}`}
                  >
                    {item?.vendor?.businessName ||
                      item?.vendor?.contactPersonName ||
                      "N/A"}
                  </a>
                </td>
                <td>₹{item?.poFinalAmountWithGST || "N/A"}</td>
                <td>₹{item?.grnFinalAmountWithGST || "N/A"}</td>

                <td>₹{item?.extraPaymentAmount || "N/A"}</td>
                <td>₹{item?.usedPaymentAmount || "N/A"}</td>
                <td>₹{item?.pendingPaymentAmount || "N/A"}</td>
                <td>{item?.paymentStatus || "N/A"}</td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item?.id)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
export default POGrnTable;
